import { render, staticRenderFns } from "./TalentPool.vue?vue&type=template&id=70e77c72&scoped=true"
import script from "./TalentPool.vue?vue&type=script&lang=js"
export * from "./TalentPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e77c72",
  null
  
)

export default component.exports